import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"placeholder, generate"} maskId="square-filled-radius-0-stroke-1-IconPlaceholder"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H6.5V4H4V6.5H3V3ZM9.5 3H14.5V4H9.5V3ZM17.5 3H21V6.5H20V4H17.5V3ZM4 9.5V14.5H3V9.5H4ZM21 9.5V14.5H20V9.5H21ZM4 17.5V20H6.5V21H3V17.5H4ZM21 17.5V21H17.5V20H20V17.5H21ZM9.5 20H14.5V21H9.5V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlaceholder;
